export default __webpack_public_path__ + "static/media/eat-icon.bd455ba1.svg";